import { render, staticRenderFns } from "./Channelpage.vue?vue&type=template&id=45ff5651"
import script from "./Channelpage.vue?vue&type=script&lang=js"
export * from "./Channelpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports